import {createSvgIcon} from '../create-svg-icon';

export const ViewComfyAltIcon = createSvgIcon(
  [<path d="M7 7h4v4H7zm6 0h4v4h-4zm-6 6h4v4H7zm6 0h4v4h-4z" key="0" />,<path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z" key="1" />,]
, 'ViewComfyAltOutlined');
